import { AxiosError } from "axios";
import { OrderListDeliverySetting } from "../models/orderListModels";

export const cloneOrderListSettings = (
  settings: OrderListDeliverySetting[]
): OrderListDeliverySetting[] => settings.map(setting => ({
  ...setting,
  categories: [...(setting.categories ?? [])],
  deliveryDays: [...(setting.deliveryDays ?? [])],
}));

export const getOrderListErrors = (error: unknown): string[] => {
  const responseData = (error as AxiosError<{
    errors?: string[] | Record<string, string[]>;
    title?: string;
    detail?: string;
  }>)?.response?.data;
  if (responseData?.errors) {
    if (Array.isArray(responseData.errors)) {
      return responseData.errors;
    }
    return Object.entries(responseData.errors).flatMap(([field, messages]) =>
      messages.map(message => `${field}: ${message}`)
    );
  }
  if (responseData?.detail || responseData?.title) {
    return [responseData.detail || responseData.title || "The settings request was rejected."];
  }
  if (typeof (error as AxiosError)?.response?.data === "string") {
    return [(error as AxiosError).response?.data as string];
  }
  return [error instanceof Error ? error.message : "Check category and delivery-day assignments."];
};

export const getOrderListSettingsErrors = getOrderListErrors;